const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <p className="footer__text">
        created by <a href="https://www.github.com/hmdnetizen">hmdNetizen</a> -
        devChallenges.io
      </p>
    </footer>
  );
};

export default Footer;
